import React from "react";
import {Columns, Heading, Modal, Section} from "react-bulma-components";


export default function InfoModal({show, setShow}){




    return (
        <Modal
            show={show}
            onClose={() => setShow(false)}
            closeOnBlur
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Hire / Hire Invoice details</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <h2 className={"bold"}>Hire Ready</h2>
                            <br/>
                            <p>A vehicle is hire ready when one of the following is true:</p>
                            <ul>
                                <li><p>- It has no hire contracts</p></li>
                                <li><p>- All hire contracts the vehicle has have an off hire date, damage indicated (Yes/No) and either do not have missing fuel/adblue or have missing fuel/adblue charges</p></li>
                                <li><p>- It has a valid qc check</p></li>
                            </ul>
                        </Columns.Column>
                        <Columns.Column>
                            <h2 className={"bold"}>Short Term Hire Invoicing</h2>
                            <br/>
                            <p>Short Term Invoices will generate either on off hire or after a week has passed whichever happens first.<br/>
                               After a week has passed invoices are generated for the previous week. If the invoice is generated on off hire it will include all days of hire.</p>
                            <br/>
                            <p>When a short term hire is off hired (when the off hire date is first entered) the following invoices are always generated:</p>
                            <ul>
                                <li><p>- An invoice for any excess mileage, missing fuel and missing adblue</p></li>
                                <li><p>- An invoice for any days of hire that were not invoiced by a previous invoice</p></li>
                            </ul>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <h2 className={"bold"}>On Hire</h2>
                            <br/>
                            <p>Conditions for a vehicle to be on hire:</p>
                            <ul>
                                <li><p>- Today is the on hire date or passed it</p></li>
                                <li><p>- Both Tracker and Insurance have been completed in the on hire section</p></li>
                                <li><p>- The contract does not have an off hire date</p></li>
                            </ul>
                            <br/>
                            <p>A vehicle will sit in upcoming on hire if the on hire date has not passed or tracker/insurance has not been completed in the on hire section.<br/>
                                If today is the on hire date it will stay in upcoming on hire till the vehicle collected box is ticked.</p>
                        </Columns.Column>
                        <Columns.Column>
                           <h2 className={"bold"}>Long Term Hire Invoicing</h2>
                            <br/>
                            <p>Long term invoices will be generated either, weekly, monthly or one off based on what is selected in the rates section of a contact.<br/>
                               An invoice is also created when the contract is made for the current week or month based on what is selected in the rates section of the contract.</p>
                            <p>Weekly invoices are generated at the start of the week they are for. Monthly invoices are generated from the 24th of the month for the next month.</p>
                            <br/>
                            <p>When a long term hire is off hired (when the off hire date is first entered) the following invoices are always generated:</p>
                            <ul>
                                <li><p>- An invoice for any excess mileage, missing fuel and missing adblue</p></li>
                                <li><p>- An invoice for any days of hire that were not invoiced by a previous invoice</p></li>
                            </ul>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <h2 className={"bold"}>Off Hire</h2>
                            <br/>
                            <p>Conditions for a vehicle to be off hired:</p>
                            <ul>
                                <li><p>- The contact has an off hire date</p></li>
                                <li><p>- The contract has damage indicated (Yes/No) in the off hire section</p></li>
                            </ul>
                            <br/>
                            <p>A vehicle that meets one but not both of the conditions above will sit in unfinished off hires.</p>
                            <br/>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )

}